/* eslint-disable */
import React from "react";
import OutfitTabCategoryFilter from "@common/NewFilter/OutfitTabFilter/CategoryFilter";
import OutfitTabHeightFilter from "@common/NewFilter/OutfitTabFilter/HeightFilter";

const getOutfitTabFilterPillContent = (props: any): any => {
  const {
    genderFilterLabel,
    heightFilterLabel,
    selectedGender,
    selectedHeight
  } = props;

  const filterPillContent = [
    {
      children: <OutfitTabCategoryFilter {...props} />,
      isSelected: selectedGender !== "All",
      label: genderFilterLabel
    },
    {
      children: <OutfitTabHeightFilter {...props} />,
      isSelected: selectedHeight !== "",
      label: heightFilterLabel
    }
  ];

  return filterPillContent;
};

export default getOutfitTabFilterPillContent;
